import { createApiRef, useApiHolder } from '@backstage/core-plugin-api';

import { FactTableOptionFragment } from '@spotify/confidence-graphql';

export interface FactTableFilterApi {
  factTableFilter: (table: FactTableOptionFragment) => boolean;
  queryFilter: string;
}

export const factTableFilterApiRef = createApiRef<FactTableFilterApi>({
  id: 'plugin.confidence-metrics.fact-table-filter',
});

export const useFactTableFilter = (): FactTableFilterApi | undefined => {
  const apis = useApiHolder();
  return apis.get(factTableFilterApiRef) ?? undefined;
};
